import { render, staticRenderFns } from "./FormToggle.vue?vue&type=template&id=5b58190b&scoped=true&"
import script from "./FormToggle.vue?vue&type=script&lang=js&"
export * from "./FormToggle.vue?vue&type=script&lang=js&"
import style0 from "./FormToggle.vue?vue&type=style&index=0&id=5b58190b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58190b",
  null
  
)

export default component.exports